<template>
  <div id="model-relic-dialog-info" class="x-center font-body">
    <div v-if="visibleSize" class="info x-center">
      <el-image
        class="info-img"
        style="width: 350px; height: 350px"
        :src="relicInfo.realisticPic[0]"
        fit="contain"
      ></el-image>
      <div class="info-left">
        <div
          class="info-left-item"
          style="color:#7f7f7f;"
          v-if="relicInfo.number"
        >
          历史建筑编号：{{ relicInfo.number }}
        </div>
        <div
          class="info-left-item"
          style="color:#7f7f7f;"
          v-if="!relicInfo.number"
        ></div>
        <div class="info-left-item">
          <span class="name">{{ relicInfo.name }}</span
          ><span class="age">{{ relicInfo.buildingAge }}</span>
        </div>
        <div class="info-left-item info-text">
          {{ relicInfo.value }}
        </div>
      </div>
      <ul class="info-right">
        <li
          class="info-right-item"
          v-for="(item, index) in infoList"
          :key="index"
          v-show="item.value"
        >
          <i :class="item.icon"></i>
          <div class="info-right-item__text">
            <div class="label">{{ item.label }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </li>
      </ul>
    </div>
    <div class="big center" v-if="!visibleSize">
      <div class="big-content">
        <el-image
          class="big-img"
          style="width: 680px; height: 680px"
          :src="relicInfo.realisticPic[0]"
          fit="contain"
        ></el-image>
        <ul class="big-info font-body">
          <li class="big-info-item" v-if="relicInfo.number">
            <span>历史建筑编号：</span><span>{{ relicInfo.number }}</span>
          </li>
          <li class="big-info-item">
            <span>建筑名称：</span><span>{{ relicInfo.name }}</span>
          </li>
          <li class="big-info-item">
            <span>年代：</span><span>{{ relicInfo.buildingAge }}</span>
          </li>
          <li
            class="big-info-item"
            v-for="(item, index) in infoList"
            :key="index"
            v-show="item.value"
          >
            <span>{{ item.label }}：</span><span>{{ item.value }}</span>
          </li>
          <li class="big-info-item">
            <span>建筑简介：</span><span>{{ relicInfo.value }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
function transformArea(data) {
  const area = data ? data + '平方米' : data;
  return area;
}
export default {
  name: 'ModelRelicDialogInfo',
  props: {
    relicInfo: {
      type: Object,
      default: () => ({})
    },
    visibleSize: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      infoList: [
        {
          icon: 'iconfont icon icon-shequ',
          label: '所在社区',
          value: this.relicInfo.community
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '建筑面积',
          value: transformArea(this.relicInfo.coveredArea)
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '保护类别',
          value: this.relicInfo.protect
        },
        {
          icon: 'iconfont icon icon-jianzhucengshu',
          label: '建筑层数',
          value: this.relicInfo.height
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '现状功能',
          value: this.relicInfo.used
        },
        {
          icon: 'iconfont icon-xianzhuangchanquan',
          label: '现状产权',
          value: this.relicInfo.equity
        },
        {
          icon: 'iconfont icon-jianzhudizhi',
          label: '地址',
          value: this.relicInfo.address
        },
        {
          icon: 'iconfont icon icon-zhandimianji',
          label: '占地面积',
          value: transformArea(this.relicInfo.floorSpace)
        },
        {
          icon: 'iconfont icon icon-jianzhujiegou',
          label: '建筑结构',
          value: this.relicInfo.structure
        }
      ]
    };
  }
};
</script>

<style lang="scss">
#model-relic-dialog-info {
  width: 100%;
  height: 100%;
  color: #fff;
  .info {
    position: relative;
    display: flex;
    width: 90vw;
    min-width: 1024px;
    &-img {
    }
    &-left {
      box-sizing: content-box;
      padding: 10px 80px;
      width: 294px;
      .info-text {
        line-height: 20px;
        margin: 0 auto;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 6;
        overflow: hidden;
      }
      &-item {
        height: 120px;
        &:nth-child(2) {
          display: flex;
          flex-direction: column;
          .name {
            font-size: 20px;
          }
          .age {
            font-size: 14px;
            color: #7f7f7f;
          }
        }
      }
    }
    &-right {
      box-sizing: content-box;
      display: flex;
      flex-wrap: wrap;
      align-self: flex-end;
      padding-left: 20px;
      margin-bottom: 10px;
      border-left: 1px solid #fff;
      width: 800px;
      height: 120px;
      &-item {
        flex: 25%;
        max-width: 200px;
        height: 50px;
        display: flex;
        .iconfont {
          font-size: 38px;
        }
        &__text {
          padding-left: 5px;
          .label {
            font-size: 16px;
          }
          .value {
            margin-top: 5px;
            font-size: 12px;
          }
        }
      }
    }
  }
  .big-info {
    align-self: center;
    width: calc(1024px - 680px);
    &-item {
      padding: 5px 0px;
      padding-left: 30px;
      line-height: 1.5em;
    }
  }
  .big-content {
    width: 1024px;
    display: inherit;
  }
}
</style>
